import { Component, Input } from "@angular/core";
import { PartyLookupDTO } from "../../../../services/swagger-gen/fordesk";

@Component({
  selector: "party-address-option",
  templateUrl: "./party-address-option.html"
})
// tslint:disable-next-line: component-class-suffix
export class PartyAddressOption {
  @Input()
  public item: PartyLookupDTO;

  constructor() { }
}
